import { render, staticRenderFns } from "./AboutStdObForm.vue?vue&type=template&id=25e97d9e&"
import script from "./AboutStdObForm.vue?vue&type=script&lang=js&"
export * from "./AboutStdObForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports